package com.patronat.top.client.presentation.home.model

import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.painter.Painter
import com.patronat.top.dto.venues.VenueCategory
import com.patronat.top.dto.venues.VenueGroup
import com.patronat.top.ui.theme.AppIcons
import org.jetbrains.compose.resources.StringResource
import top.clientapp.generated.resources.Res
import top.clientapp.generated.resources.*

fun VenueGroup.labelRes(): StringResource = when (this) {
    VenueGroup.FOOD -> Res.string.venue_group_food
    VenueGroup.SHOPPING -> Res.string.venue_group_shopping
    VenueGroup.BEAUTY -> Res.string.venue_group_beauty
    VenueGroup.HEALTH -> Res.string.venue_group_health
    VenueGroup.AUTO -> Res.string.venue_group_auto
    VenueGroup.HOME -> Res.string.venue_group_home
    VenueGroup.EDUCATION -> Res.string.venue_group_education
    VenueGroup.BUSINESS -> Res.string.venue_group_business
    VenueGroup.IT_MEDIA -> Res.string.venue_group_it_media
    VenueGroup.LOGISTICS -> Res.string.venue_group_logistics
    VenueGroup.ENTERTAINMENT -> Res.string.venue_group_entertainment
    VenueGroup.PETS -> Res.string.venue_group_pets
    VenueGroup.HOUSEHOLD -> Res.string.venue_group_household
    VenueGroup.EVENTS -> Res.string.venue_group_events
    VenueGroup.TRAVEL -> Res.string.venue_group_travel
}

fun VenueCategory.labelRes(): StringResource = when (this) {
    VenueCategory.RESTAURANT -> Res.string.venue_category_restaurant
    VenueCategory.COFFEE_SHOP -> Res.string.venue_category_coffee_shop
    VenueCategory.BAR_PUB -> Res.string.venue_category_bar_pub
    VenueCategory.BAKERY_CONFECTIONERY -> Res.string.venue_category_bakery_confectionery
    VenueCategory.PIZZERIA -> Res.string.venue_category_pizzeria
    VenueCategory.SUSHI_ASIAN -> Res.string.venue_category_sushi_asian
    VenueCategory.FAST_FOOD -> Res.string.venue_category_fast_food
    VenueCategory.STEAK_HOUSE -> Res.string.venue_category_steak_house
    VenueCategory.CATERING_DELIVERY -> Res.string.venue_category_catering_delivery
    VenueCategory.BREAKFAST_BRUNCH -> Res.string.venue_category_breakfast_brunch
    VenueCategory.GROCERY_SUPERMARKET -> Res.string.venue_category_grocery_supermarket
    VenueCategory.MEAT_DAIRY_SHOP -> Res.string.venue_category_meat_dairy_shop
    VenueCategory.CLOTHING_SHOES -> Res.string.venue_category_clothing_shoes
    VenueCategory.COSMETICS_PERFUMERY -> Res.string.venue_category_cosmetics_perfumery
    VenueCategory.ELECTRONICS -> Res.string.venue_category_electronics
    VenueCategory.FURNITURE_DECOR -> Res.string.venue_category_furniture_decor
    VenueCategory.CONSTRUCTION_MATERIALS -> Res.string.venue_category_construction_materials
    VenueCategory.PET_SHOP -> Res.string.venue_category_pet_shop
    VenueCategory.BOOKSTORE_STATIONERY -> Res.string.venue_category_bookstore_stationery
    VenueCategory.FLOWER_SHOP -> Res.string.venue_category_flower_shop
    VenueCategory.HAIRDRESSER -> Res.string.venue_category_hairdresser
    VenueCategory.BARBERSHOP -> Res.string.venue_category_barbershop
    VenueCategory.MANICURE_PEDICURE -> Res.string.venue_category_manicure_pedicure
    VenueCategory.COSMETOLOGY -> Res.string.venue_category_cosmetology
    VenueCategory.SPA_MASSAGE -> Res.string.venue_category_spa_massage
    VenueCategory.SOLARIUM -> Res.string.venue_category_solarium
    VenueCategory.TATTOO_PIERCING -> Res.string.venue_category_tattoo_piercing
    VenueCategory.LASER_HAIR_REMOVAL -> Res.string.venue_category_laser_hair_removal
    VenueCategory.CLINIC_GP -> Res.string.venue_category_clinic_gp
    VenueCategory.DENTISTRY -> Res.string.venue_category_dentistry
    VenueCategory.LABORATORY -> Res.string.venue_category_laboratory
    VenueCategory.AESTHETIC_MEDICINE -> Res.string.venue_category_aesthetic_medicine
    VenueCategory.VETERINARY_CLINIC -> Res.string.venue_category_veterinary_clinic
    VenueCategory.PSYCHOTHERAPY -> Res.string.venue_category_psychotherapy
    VenueCategory.PHARMACY -> Res.string.venue_category_pharmacy
    VenueCategory.OPTICS -> Res.string.venue_category_optics
    VenueCategory.CAR_SERVICE -> Res.string.venue_category_car_service
    VenueCategory.CAR_WASH -> Res.string.venue_category_car_wash
    VenueCategory.AUTO_PARTS -> Res.string.venue_category_auto_parts
    VenueCategory.TIRE_SERVICE -> Res.string.venue_category_tire_service
    VenueCategory.CAR_DEALERSHIP -> Res.string.venue_category_car_dealership
    VenueCategory.TUNING_DETAILING -> Res.string.venue_category_tuning_detailing
    VenueCategory.CAR_INSURANCE -> Res.string.venue_category_car_insurance
    VenueCategory.TAXI_RENTAL -> Res.string.venue_category_taxi_rental
    VenueCategory.CONSTRUCTION_COMPANY -> Res.string.venue_category_construction_company
    VenueCategory.RENOVATION_DESIGN -> Res.string.venue_category_renovation_design
    VenueCategory.PLUMBING_ELECTRIC -> Res.string.venue_category_plumbing_electric
    VenueCategory.WINDOWS_DOORS -> Res.string.venue_category_windows_doors
    VenueCategory.HEATING_AC -> Res.string.venue_category_heating_ac
    VenueCategory.REAL_ESTATE_AGENCY -> Res.string.venue_category_real_estate_agency
    VenueCategory.CLEANING -> Res.string.venue_category_cleaning
    VenueCategory.WASTE_REMOVAL -> Res.string.venue_category_waste_removal
    VenueCategory.LANGUAGE_COURSES -> Res.string.venue_category_language_courses
    VenueCategory.TUTORING -> Res.string.venue_category_tutoring
    VenueCategory.KINDERGARTEN_SCHOOL -> Res.string.venue_category_kindergarten_school
    VenueCategory.UNIVERSITY_COLLEGE -> Res.string.venue_category_university_college
    VenueCategory.ONLINE_COURSES -> Res.string.venue_category_online_courses
    VenueCategory.MUSIC_ART_SCHOOL -> Res.string.venue_category_music_art_school
    VenueCategory.TRAINING_CENTER -> Res.string.venue_category_training_center
    VenueCategory.BANK_CREDIT -> Res.string.venue_category_bank_credit
    VenueCategory.ACCOUNTING_AUDIT -> Res.string.venue_category_accounting_audit
    VenueCategory.LEGAL_NOTARY -> Res.string.venue_category_legal_notary
    VenueCategory.INSURANCE_COMPANY -> Res.string.venue_category_insurance_company
    VenueCategory.TAX_CONSULTING -> Res.string.venue_category_tax_consulting
    VenueCategory.BUSINESS_CONSULTING -> Res.string.venue_category_business_consulting
    VenueCategory.COWORKING -> Res.string.venue_category_coworking
    VenueCategory.WEB_DEVELOPMENT -> Res.string.venue_category_web_development
    VenueCategory.MARKETING_SMM_SEO -> Res.string.venue_category_marketing_smm_seo
    VenueCategory.PRODUCTION_PHOTO_VIDEO -> Res.string.venue_category_production_photo_video
    VenueCategory.IT_SUPPORT -> Res.string.venue_category_it_support
    VenueCategory.COPYWRITING_TRANSLATION -> Res.string.venue_category_copywriting_translation
    VenueCategory.UX_UI_DESIGN -> Res.string.venue_category_ux_ui_design
    VenueCategory.COURIER_SERVICE -> Res.string.venue_category_courier_service
    VenueCategory.POST_DELIVERY -> Res.string.venue_category_post_delivery
    VenueCategory.EQUIPMENT_RENTAL -> Res.string.venue_category_equipment_rental
    VenueCategory.MOVING_SERVICE -> Res.string.venue_category_moving_service
    VenueCategory.WAREHOUSING -> Res.string.venue_category_warehousing
    VenueCategory.CINEMA -> Res.string.venue_category_cinema
    VenueCategory.BOWLING_BILLIARDS -> Res.string.venue_category_bowling_billiards
    VenueCategory.QUEST_VR -> Res.string.venue_category_quest_vr
    VenueCategory.NIGHT_CLUB -> Res.string.venue_category_night_club
    VenueCategory.KIDS_ENTERTAINMENT -> Res.string.venue_category_kids_entertainment
    VenueCategory.TOURISM_HOTELS -> Res.string.venue_category_tourism_hotels
    VenueCategory.VET_SERVICES -> Res.string.venue_category_vet_services
    VenueCategory.GROOMING -> Res.string.venue_category_grooming
    VenueCategory.PET_HOTEL -> Res.string.venue_category_pet_hotel
    VenueCategory.DOG_TRAINING -> Res.string.venue_category_dog_training
    VenueCategory.DRY_CLEANING -> Res.string.venue_category_dry_cleaning
    VenueCategory.SHOE_CLOTHES_REPAIR -> Res.string.venue_category_shoe_clothes_repair
    VenueCategory.TECH_REPAIR -> Res.string.venue_category_tech_repair
    VenueCategory.KEYS_LOCKS -> Res.string.venue_category_keys_locks
    VenueCategory.PRINTING_COPY -> Res.string.venue_category_printing_copy
    VenueCategory.EVENT_AGENCY -> Res.string.venue_category_event_agency
    VenueCategory.EVENT_PHOTO_VIDEO -> Res.string.venue_category_event_photo_video
    VenueCategory.HOST_DJ -> Res.string.venue_category_host_dj
    VenueCategory.DRESS_RENTAL -> Res.string.venue_category_dress_rental
    VenueCategory.HALL_RENTAL -> Res.string.venue_category_hall_rental
    VenueCategory.EVENT_CATERING -> Res.string.venue_category_event_catering
    VenueCategory.TRAVEL_AGENCY -> Res.string.venue_category_travel_agency
    VenueCategory.HOTEL_HOSTEL -> Res.string.venue_category_hotel_hostel
    VenueCategory.VEHICLE_RENTAL -> Res.string.venue_category_vehicle_rental
    VenueCategory.TRANSFER_TAXI -> Res.string.venue_category_transfer_taxi
    VenueCategory.GAS_STATION_EV -> Res.string.venue_category_gas_station_ev
}

@Composable
fun VenueGroup.icon(): Painter = when (this) {
    VenueGroup.FOOD -> AppIcons.VenueGroupFood
    VenueGroup.SHOPPING -> AppIcons.VenueGroupShopping
    VenueGroup.BEAUTY -> AppIcons.VenueGroupBeauty
    VenueGroup.HEALTH -> AppIcons.VenueGroupHealth
    VenueGroup.AUTO -> AppIcons.VenueGroupAuto
    VenueGroup.HOME -> AppIcons.VenueGroupHome
    VenueGroup.EDUCATION -> AppIcons.VenueGroupEducation
    VenueGroup.BUSINESS -> AppIcons.VenueGroupBusiness
    VenueGroup.IT_MEDIA -> AppIcons.VenueGroupItMedia
    VenueGroup.LOGISTICS -> AppIcons.VenueGroupLogistics
    VenueGroup.ENTERTAINMENT -> AppIcons.VenueGroupEntertainment
    VenueGroup.PETS -> AppIcons.VenueGroupPets
    VenueGroup.HOUSEHOLD -> AppIcons.VenueGroupHousehold
    VenueGroup.EVENTS -> AppIcons.VenueGroupEvents
    VenueGroup.TRAVEL -> AppIcons.VenueGroupTravel
}
